import React from "react";
import {ContentStylesColourBlock, ContentStylesDemoSubsection,} from "../ContentStylesHelper";

const EDIT_TYPES = {
    BLOCK: "cont-block-simple-*",
    MAIN: "cont-block-simple-*-main-colour",
}

export const simpleBlockStylesRegistry = {
    [EDIT_TYPES.BLOCK]: {title: 'Simple block @', slave: EDIT_TYPES.MAIN},
    [EDIT_TYPES.MAIN]: {title: 'Simple block colour @', cssVar: ["--cont-block-simple-*-bg"]},
}

export const SimpleBlockStyles = props => {
    const {variant, updateStylesCallback} = props;

    return (
        <>
            <h5>Colour</h5>
            <ContentStylesColourBlock
                editType={EDIT_TYPES.MAIN}
                variant={variant}
                colourConfig={simpleBlockStylesRegistry[EDIT_TYPES.MAIN]}
                onChange={updateStylesCallback}
            />
        </>
    )
}

export const SimpleBlockDemo = props => {
    const {demoEvents, totalVariants} = props;

    return (
        <ContentStylesDemoSubsection>
            {[...Array(totalVariants)].map((_, i) => {
                const variantNum = i + 1;
                const classKey = `cont-block-simple-${variantNum}`;
                const groupKey = `simpleBlocks${variantNum}`;

                return (
                    <div
                        key={classKey}
                        id={`preview-section-${groupKey}`}
                        className={`cont-block ${classKey}`}
                        {...demoEvents(classKey)}
                    >
                        <div className='cont-block-head'>
                            Simple block {variantNum}
                        </div>
                        <div className='cont-block-body'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </div>
                    </div>
                );
            })}
        </ContentStylesDemoSubsection>
    );
};